module.exports = __webpack_public_path__ + "static/cebe-fb7558eaadcd5b2eb56b0211117769bd.png";